import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { useCountryCode, useLocale } from '#src/app/shared/hooks/l10n';

import { prefetchPolicyPageDataFromApi, usePolicyPageDataFromApi } from './pageData';

export type PolicyPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof usePolicyPageDataFromApi>[0]>;
}>;

export type PolicyPageCombinedState = ReturnType<typeof usePolicyPageDataFromApi>;

export function usePageContext(
	slug: string | undefined,
	prefetchedData?: PolicyPagePrefetchedContext,
): PolicyPageCombinedState {
	const l10n = {
		countryCode: useCountryCode(),
		locale: useLocale(),
	};
	return usePolicyPageDataFromApi(prefetchedData?.pageData, slug, l10n);
}

export async function prefetchPageContext(
	slug: string | undefined,
	context: PrefetchContext,
): Promise<PolicyPagePrefetchedContext> {
	return { pageData: await prefetchPolicyPageDataFromApi(context, slug, context.l10n) };
}

export type PolicyPagePrefetchedDataProps = PrefetchedDataProps<PolicyPagePrefetchedContext>;
